class ProductBundle {
    constructor() {
        this.body = document.body;
        this.product = document.querySelector('.product');
        this.bundleSelect = document.getElementById('filter');
        this.bundleSelectOptions = document.querySelectorAll('#filter option');
        this.bundledProducts = document.querySelectorAll('.bundled_product');
        this.skinTypes = [];

        this.initEvents();
    }

    initEvents() {
        // Collect available skintypes from bundled products
        this.bundledProducts.forEach(product => {
            const skintypeElement = product.querySelector('.details .bundled_item_skintype');

            if (skintypeElement) {
                const skintype = skintypeElement.getAttribute('data-skintype');
                if (skintype) {
                    this.skinTypes.push(skintype);
                }
            } else {
                console.warn('Skintype element not found for a bundled product. Please check if the product has a skintype.');
            }
        });

        // Remove duplicates from the skintypes array
        this.skinTypes = [...new Set(this.skinTypes)];

        // Hide unused options in the bundle select
        this.bundleSelectOptions.forEach(option => {
            if (option.value !== 'none' && !this.skinTypes.includes(option.value)) {
                option.style.display = 'none';
            }
        });

        // Add event listener if this is a bundled product
        if (this.isBundledProduct() && this.bundleSelect) {
            this.bundleSelect.addEventListener('change', this.handleSelectChange.bind(this));
        }
    }

    isBundledProduct() {
        return this.body?.classList.contains('single-product') && this.product?.classList.contains('product-type-bundle');
    }

    handleSelectChange(e) {
        const selectedValue = e.target.value;

        console.log(selectedValue);

        this.bundledProducts.forEach(product => {
            const bundledProductCheckbox = product.querySelector('.bundled_product_checkbox');

            // Check if the product matches the selected skintype
            if (product.classList.contains(selectedValue)) {
                bundledProductCheckbox.checked = true;
            } else {
                bundledProductCheckbox.checked = false;
            }

            // Trigger change event to update WooCommerce bundle data
            $(bundledProductCheckbox).trigger('change');
        });

        const bundle = $('.bundle_form').wc_get_bundle_script();
        bundle.$bundle_data.trigger('woocommerce-product-bundle-update-totals');
    }
}

document.addEventListener('DOMContentLoaded', () => {
    new ProductBundle();
});
